import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import {
  Avatar,
  InputBase,
  Button,
  IconButton,
  Typography,
  TextField,
  MenuItem,
  Tooltip,
  useMediaQuery,
  CircularProgress,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Announcement, Close, Newspaper } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { useLocation, useParams } from "react-router-dom";
import PublicIcon from "@mui/icons-material/Public";
import ImageIcon from "@mui/icons-material/Image";
import PhotoSizeSelectActualOutlinedIcon from "@mui/icons-material/PhotoSizeSelectActualOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import { getStringifyItem, show_proper_words } from "../../utils/Constant";
import { update_feed_image_on_s3 } from "../../DAL/TalentSourceAPI/TalentSourceApi";
import { s3baseUri } from "../../config/config";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
  vid_icon,
  img_icon,
} from "../../assets";
import { useIds } from "../../hook/AdminContext";
import LinkPreview from "../../components/previewUrl/PreviewsUrl";
import { add_new_feed, update_new_feed } from "../../DAL/feed/feed";
import PostUploadImages from "../../components/PostImagesComponents/PostUploadImages";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 581,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
  borderRadius: 2,
  outline: "none",
};

export default function CreatePost({
  setFeedType,
  feedType,
  openCreateModal,
  userInfo,
  setOpenCreateModal,
  selectedFeed,
  getFeedsListing,
  type,
  previewLink,
  setPreviewLink,
}) {
  let typeTosend = type;
  const { activeSourceList, findId } = useIds();
  const { pathname } = useLocation();
  const [previews, setPreviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [forcePreview, setForcePreview] = useState(false);

  const params = useParams();
  const sourceSlug = params?.source_slug || "";

  const [inputs, setInputs] = useState({
    description: "",
    created_for: "",
    video_url: "",
  });
  const [isFocused, setIsFocused] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const inputRef = useRef(null);
  const handleChange = async (e) => {
    let { name, value } = e.target;
    setInputs((values) => ({ ...values, [name]: value }));

    if (type === "EDIT" && name === "description") {
      const oldUrl = extractURL(selectedFeed?.description || "");
      const newUrl = extractURL(value || "");

      if (newUrl && newUrl !== oldUrl) {
        setPreviewLink(true);
      } else {
        setPreviewLink(false);
      }
    }

    setIsFocused(false);
  };

  const UploadImages = async (formData) => {
    const result = await update_feed_image_on_s3(formData);
    return result.image_path;
  };
  const extractURL = (str) => {
    // Match http(s) URLs or www. URLs
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/gi;
    const match = str?.match(urlRegex);

    if (match && match[0]) {
      const url = match[0];
      // Agar url 'www.' se shuru hota hai, prepend 'http://'
      if (url.startsWith("www.")) {
        return "http://" + url;
      }
      return url;
    }
    return null;
  };
  const linkInDescription = extractURL(inputs.description);
  const filteredData = userInfo.source;
  const docTypeImages = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  const getSortedMedia = (list) => {
    const files = [];
    const existingItem = [];

    list.forEach((item) => {
      if (item instanceof File) {
        files.push(item);
      } else if (item?.path instanceof File) {
        files.push(item.path);
      } else {
        existingItem.push(item);
      }
    });

    if (existingItem.length > 0) {
      return [existingItem, ...files];
    } else {
      return [...files];
    }
  };

  const getDeletedObjects = () => {
    if (!selectedFeed?.media || selectedFeed?.media.length == 0) return [];
    return selectedFeed?.media.filter((item1) => {
      const existsInArray2 = previews.some((item2) => {
        if (typeof item2 instanceof File) {
          return false;
        }
        return item1.thumbnail_1 === item2.thumbnail_1;
      });

      return !existsInArray2;
    });
  };

  const handlePost = async (e) => {
    e.preventDefault();
    // if (!inputs.video_url && !inputs.description && previews.length < 1) {
    //   enqueueSnackbar(
    //     "At least one type of content must be included in the feed: description, document, video, or image.",
    //     { variant: "error" }
    //   );
    //   return;
    // }
    if (!inputs.description && feedType === "general") {
      enqueueSnackbar("Description is required ", { variant: "error" });
      return;
    }

    if (feedType === "image" && previews.length === 0) {
      enqueueSnackbar("please upload image ", { variant: "error" });
      return;
    }

    if (feedType === "video" && !inputs.video_url) {
      enqueueSnackbar("please upload Video ", { variant: "error" });
      return;
    }

    if (feedType === "document" && previews.length === 0) {
      enqueueSnackbar("Please upload document", { variant: "error" });
      return;
    }

    const formData = new FormData();
    formData.append(
      "is_link_preview",
      extractURL(inputs.description) ? true : false
    );
    formData.append("description", inputs.description);
    if (type === "ADD") {
      formData.append(
        "source_slug",
        sourceSlug ? sourceSlug : inputs.created_for
      );
    }
    if (feedType === "image") {
      if (previews.length > 0) {
        let sortedImages = getSortedMedia(previews);
        sortedImages.forEach((item) => {
          if (item instanceof File) {
            formData.append("image", item);
          } else {
            formData.append("image", getStringifyItem(item));
          }
        });
      }
      formData.append("feed_type", "image");
    } else if (feedType === "document") {
      if (previews.length > 0) {
        let sortedDocs = getSortedMedia(previews);
        sortedDocs.forEach((item) => {
          if (item instanceof File) {
            formData.append("document", item);
          } else {
            formData.append("document", getStringifyItem(item));
          }
        });
      }

      formData.append("feed_type", "document");
    } else if (feedType === "video") {
      formData.append("feed_type", "video");
      formData.append("video_url", inputs.video_url);
    } else {
      formData.append("feed_type", "general");
    }

    if (type != "ADD") {
      if (feedType == "image") {
        let array = getDeletedObjects();
        array = array.map((obj) => obj.thumbnail_1);
        formData.append("deleted_files", getStringifyItem(array));
      }
    }

    if (type == "ADD" && userInfo.isCompanyProfile) {
      formData.append("action_id", userInfo._id);
    }
    setIsLoading(true);
    const result =
      type === "ADD"
        ? await add_new_feed(formData)
        : await update_new_feed(formData, selectedFeed._id);
    if (result.code === 200) {
      setInputs((values) => ({
        ...values,
        description: "",
        created_for: "",
        video_url: "",
      }));
      getFeedsListing(`api/feed/feed_list?page=0&limit=50`, result.feed);
      setPreviews([]);
      setIsLoading(false);
      handleClose();
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleRemoveImage = (index) => {
    setPreviews((images) => images.filter((_, i) => i !== index));
  };

  const getImagePreview = (file) => {
    if (file instanceof File) {
      const ext = file.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file);
      } else if (docTypeImages[ext]) {
        return docTypeImages[ext];
      } else {
        return docTypeImages.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (docTypeImages[ext]) {
        return docTypeImages[ext];
      } else {
        return docTypeImages.other;
      }
    }
  };

  const handleUpload = async (event) => {
    const fileList = event.target.files;
    const imagesToAdd = [];

    for (let i = 0; i < fileList.length; i++) {
      imagesToAdd.push(fileList[i]);
    }

    setPreviews((prevFiles) => [...prevFiles, ...imagesToAdd]);
  };

  const handleClose = () => {
    if (type === "ADD") {
      setInputs((values) => ({ ...values, video_url: "" }));
      setInputs((values) => ({ ...values, description: "" }));

      setPreviews([]);
    }
    if (type === "EDIT") {
      setInputs((values) => ({ ...values, video_url: selectedFeed.video_url }));
      setInputs((values) => ({
        ...values,
        description: selectedFeed.description,
      }));
    }
    setOpenCreateModal(false);
  };

  const typeMapping = {
    hospitality: "Hospitality",
    warehouse: "Warehouse_Logistics",
    healthcare: "Healthcare_Source",
    "office-source": "Office_Source",
    "retail-source": "Retail_Source",
    "food-source": "Food_Source",
    "construction-source": "Construction_Source",
    "fit-out-source": "Fit_Out_Source",
  };

  const handleVideoTypeChange = (value) => {
    setFeedType(value);
    setInputs((prevInputs) => ({
      ...prevInputs,
      video_url: "",
    }));
    setPreviews([]);
  };

  useEffect(() => {
    if (type === "EDIT") {
      let find_create = userInfo.source.find(
        (obj) => obj._id == selectedFeed._id
      );
      setInputs((values) => ({
        ...values,
        video_url: selectedFeed.video_url,
        description: selectedFeed.description,
        created_for: find_create?.source_slug || "",
      }));

      setFeedType(selectedFeed.feed_type);
      setPreviewData(selectedFeed?.is_link_preview);
      if (
        selectedFeed.feed_type == "image" &&
        selectedFeed.media &&
        selectedFeed.media.length > 0
      ) {
        setPreviews(selectedFeed.media);
      }
      if (
        selectedFeed.feed_type == "document" &&
        selectedFeed.media &&
        selectedFeed.media.length > 0
      ) {
        setPreviews(selectedFeed.media);
      }
    } else {
      setInputs({
        video_url: "",
        description: "",
        created_for: "",
      });
      setPreviews([]);
    }
  }, [type, activeSourceList, selectedFeed]);

  useEffect(() => {
    if (!inputs.created_for && filteredData.length > 0) {
      setInputs((values) => ({
        ...values,
        created_for: filteredData[0].source_slug,
      }));
    }
  }, [filteredData, inputs.created_for, sourceSlug]);

  useEffect(() => {
    if (type === "ADD") {
      setPreviewLink(true);
    }
  }, [type]);
  useEffect(() => {
    if (type === "EDIT") {
      const oldUrl = extractURL(selectedFeed?.description);
      const newUrl = extractURL(inputs.description);
      if (newUrl && newUrl !== oldUrl) {
        setForcePreview(true);
      } else {
        setForcePreview(false);
      }
    }
  }, [inputs.description, type, selectedFeed]);

  return (
    <div className="container-fluid col-12 ">
      <Modal open={openCreateModal}>
        <Box
          sx={{
            ...style,
            width: { xs: "90%", sm: "80%", md: "50%" },
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px",
              marginLeft: "9px",
              marginRight: "9px",
            }}
          >
            <h4 className="groups-text">
              {type === "EDIT" ? "Update Post" : "Create a Post"}
            </h4>
            <Close className="red-cross" onClick={handleClose} />
          </div>
          <div className="create-post-content">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <Avatar
                src={
                  s3baseUri +
                  userInfo?.company_profile?.profile_image?.thumbnail_1
                }
              />
              <Box ml={2}>
                <div variant="subtitle1" className="mui-typo-heading">
                  <span>{userInfo?.company_profile?.company_name}</span>
                </div>
                {type == "ADD" && (
                  <Box display="flex" alignItems="center" gap={2} width="100%">
                    {/* <TextField
                      select
                      size="small"
                      variant="outlined"
                      label="Type"
                      name="post_type"
                      value={inputs.post_type || "resources"}
                      onChange={handleChange}
                      inputRef={inputRef}
                      sx={{
                        marginTop: "8px",
                        maxWidth: isMobile ? 131 : 134,
                        "& .MuiInputLabel-root": {
                          fontSize: "14px",
                        },

                        "& .MuiOutlinedInput-root": {
                          borderRadius: "5px",
                          height: 30,
                          fontSize: "12px",
                          display: "flex",
                          alignItems: "center",
                          borderColor: isFocused ? "var(--portal-primary-color)" : "#ccc",
                        },
                        "& .MuiInputBase-root": {
                          minHeight: "30px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiSelect-select": {
                          padding: "4px 8px",
                          display: "flex",
                          alignItems: "center",
                        },
                        "& .MuiOutlinedInput-root.Mui-focused": {
                          borderColor: "var(--portal-primary-color)",
                        },
                      }}
                      InputProps={{
                        disableUnderline: true,
                      }}
                    >
                      <MenuItem
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        value="resources"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <PublicIcon sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">Resources</span>
                      </MenuItem>
                      <MenuItem
                        value="annoucement"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <Announcement sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">Announcement</span>
                      </MenuItem>
                      <MenuItem
                        value="news"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <Newspaper sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">News</span>
                      </MenuItem>
                      <MenuItem
                        value="general"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <ImageIcon sx={{ fontSize: 14, color: "#daa520" }} />
                        <span className="span-post">General feed</span>
                      </MenuItem>
                    </TextField> */}
                    {pathname === "/home" && type === "ADD" ? (
                      <Box
                        sx={{ flexGrow: 1, minWidth: 200, marginTop: "3px" }}
                      >
                        <TextField
                          size="small"
                          fullWidth
                          variant="outlined"
                          select
                          label="Select page for post"
                          name="created_for"
                          value={inputs.created_for || ""}
                          onChange={handleChange}
                          sx={{
                            marginTop: "8px",
                            maxWidth: isMobile ? 120 : 175,
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "5px",
                              height: 32,
                              fontSize: "13px",
                              padding: "4px",
                              display: "flex",
                              alignItems: "center",
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "13px",
                            },
                          }}
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                style: {
                                  maxHeight: 40 * 4.5, // 4 items visible, baaki scroll
                                },
                              },
                            },
                          }}
                        >
                          {filteredData && filteredData.length > 0 ? (
                            filteredData.map((option, index) => (
                              <MenuItem key={index} value={option.source_slug}>
                                {show_proper_words(option.title)}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem disabled>No options available</MenuItem>
                          )}
                        </TextField>
                      </Box>
                    ) : (
                      ""
                    )}
                  </Box>
                )}
              </Box>
            </div>

            <InputBase
              fullWidth
              placeholder="What do you want to talk about..."
              value={inputs.description}
              onChange={handleChange}
              name="description"
              multiline
              rows={4}
              className="create-post-text-input"
            />
            <div className="col-12 mb-3">
              {feedType == "video" && (
                <div className="col-12 mt-3 video-url-field">
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Video URL"
                    size="small"
                    name="video_url"
                    required
                    value={inputs.video_url}
                    type="url"
                    onChange={handleChange}
                    placeholder="Video URL"
                  />
                  <span
                    className="video-url-cross"
                    onClick={() => {
                      setInputs((values) => ({ ...values, video_url: "" }));
                      setPreviewLink(true);
                      setFeedType("general");
                    }}
                  >
                    x
                  </span>
                </div>
              )}
              {linkInDescription &&
                feedType !== "image" &&
                feedType !== "document" &&
                feedType !== "video" && (
                  <LinkPreview
                    setInputs={setInputs}
                    text={linkInDescription}
                    previewLink={previewLink}
                    setPreviewLink={setPreviewLink}
                    type={"icon_show"}
                    previewData={previewData}
                    setPreviewData={setPreviewData}
                    selectedFeed={selectedFeed}
                    typeData={typeTosend}
                    forcePreview={forcePreview}
                  />
                )}

              {feedType === "image" ? (
                <div className="col-12 mt-2">
                  <PostUploadImages
                    previews={previews}
                    setPreviews={setPreviews}
                  />
                </div>
              ) : (
                ""
              )}
              {feedType === "document" ? (
                <div className="col-12 mt-2">
                  <div className="row justify-content-center">
                    {previews.length > 0 &&
                      previews.map((preview, index) => {
                        if (preview) {
                          return (
                            <span className="col-2 mb-3 preview create-post-images">
                              <span
                                onClick={() => {
                                  handleRemoveImage(index);
                                }}
                              >
                                x
                              </span>
                              <img
                                className="img-fluid"
                                src={getImagePreview(
                                  preview?.thumbnail_1
                                    ? preview?.thumbnail_1
                                    : preview
                                )}
                              />
                            </span>
                          );
                        }
                      })}
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <span className="upload-button mt-2 w-100">
                        <input
                          multiple
                          color="primary"
                          accept={
                            feedType === "image"
                              ? "image/*"
                              : ".pdf, .doc, .docx, .txt"
                          }
                          type="file"
                          id="icon-button-file"
                          style={{ display: "none" }}
                          onChange={handleUpload}
                        />
                        <label htmlFor="icon-button-file">
                          <span
                            onClick={() => {
                              setFeedType("general");
                            }}
                          >
                            x
                          </span>
                          <p className="mt-3">
                            {feedType === "image" ? (
                              <>
                                Add Photo <br />
                                <CloudUploadIcon />
                              </>
                            ) : (
                              <>
                                Add Document <br />
                                <CloudUploadIcon />
                              </>
                            )}
                          </p>
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="my-3 row align-items-center">
                <div className="col-12 col-lg-9">
                  <Tooltip title="Upload Document">
                    <IconButton
                      className={
                        feedType === "document"
                          ? "mui-chip-all chip-active"
                          : "mui-chip-all"
                      }
                      onClick={() => {
                        handleVideoTypeChange("document");
                      }}
                    >
                      <TextSnippetOutlinedIcon
                        style={{
                          color: "rgba(0, 0, 0, 1)",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Upload Photo">
                    <IconButton
                      className={
                        feedType === "image"
                          ? "mui-chip-all chip-active"
                          : "mui-chip-all"
                      }
                      onClick={() => {
                        handleVideoTypeChange("image");
                      }}
                    >
                      <img src={img_icon} width={24} alt="" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Upload Video">
                    <IconButton
                      className={
                        feedType === "video"
                          ? "mui-chip-all chip-active"
                          : "mui-chip-all"
                      }
                      onClick={() => {
                        handleVideoTypeChange("video");
                      }}
                    >
                      <img src={vid_icon} width={24} alt="" />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="col-12 col-lg-3 mt-2 mt-lg-0">
                  <Button
                    fullWidth
                    variant="contained"
                    className="contain-button-mui"
                    style={{
                      backgroundColor: "var(--portal-primary-color)",
                      color: "white",
                    }}
                    disabled={isLoading}
                    onClick={handlePost}
                  >
                    {isLoading ? (
                      <>
                        <CircularProgress
                          size={14}
                          color="inherit"
                          sx={{ position: "relative", right: "10px" }}
                        />

                        {type === "EDIT" ? "Updating..." : "Posting..."}
                      </>
                    ) : (
                      <>{type === "EDIT" ? " Update" : "Post"}</>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
